import {Injectable, Inject} from 'ng-metadata/core';
import {getVid,getInstitutionCode} from '../../../appConfig/appConfigForward';

@Injectable()
export class BrowseSearchBarService {

    private _searchBarInput: string;
    private _selectedScope;
    private _scopes:Object[];
    private _scopesProgress:boolean=false;
    constructor(@Inject('$http') private $http : ng.IHttpService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('restBaseURLs') private restBaseURLs){}

    public getLinkScopes(){
        let viewId:string = getVid();
        let config = {"params":{"vid":viewId}};
        var promise = this.$http.get(this.restBaseURLs.browse +"/browseList",config);
        return promise;
    }


    get scopesProgress(): boolean {
        return this._scopesProgress;
    }

    set scopesProgress(value: boolean) {
        this._scopesProgress = value;
    }


    public get searchBarInput(): string{
        return this._searchBarInput;
    }

    public set searchBarInput(newSearchInput: string){
        this._searchBarInput= newSearchInput;
    }

    public get selectedScope(): Object{
        return this._selectedScope;
    }

    public set selectedScope(newScope: Object){
        this._selectedScope= newScope;
    }


    public setSlectedScope(){
        if(this.$state.params['browseScope'] != null){
            let scope:Object;

            for(scope of this.scopes) {
                if (scope['SourceCode1'] == this.$state.params['browseScope']) {
                    this.selectedScope = scope;
                    break;
                }
            }
        };
    }




    public set scopes(allScopes: Object[]){
        this._scopes= allScopes;
    }

    public get scopes(): Object[]{
        return this._scopes;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseSearchBar/browseSearchBar.service.ts